module.exports = __webpack_public_path__ + "static/media/new-logo.53337a13.png";